<div class="col-12" style=" margin-top: 15px;">
  <h4> {{"shopping"| transloco }}</h4>
</div>
<div class="scroll-menu">

  <div class="scroll-item" routerLink="/toprated">
    <img src="/assets/e-commerce/icons/78.webp">

    <p>{{ "top rated" | transloco }}</p>
  </div>
  <div class="scroll-item" routerLink="/dailyoffers">
    <img src="/assets/e-commerce/icons/79.webp">
    <p>{{ "daily_offer" | transloco }}

    </p>

  </div>
  <div class="scroll-item" routerLink="/deals">
    <img src="/assets/e-commerce/icons/81.webp">
    <p>{{ "deals" | transloco }}</p>
  </div>
  <div class="scroll-item" routerLink="/mostsales">
    <img src="/assets/e-commerce/icons/80.webp">
    <p>{{ "mostSales" | transloco }}</p>
  </div>
  <div class="scroll-item" routerLink="/topsale">
    <img src="/assets/e-commerce/icons/82.webp">
    <p>{{ "hot deals" | transloco }}</p>
  </div>

</div>